import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { SlideDown } from 'react-slidedown'
// import config from 'config'
import format from '../../helpers/format'
import {
  // Link,
  LinkIcon,
  AmazonResolutionText,
  CampbellSoupResolutionText,
  ComcastResolutionText,
  MicrosoftResolutionText,
} from '../'

import Styles from './PlanScorecardShareholderResolution.css'

@CSSModules(Styles, {allowMultiple: true})
export default class PlanScorecardShareholderResolution extends Component {
  static propTypes = {
    planId: PropTypes.string.isRequired,
    planData: PropTypes.object.isRequired,
    url: PropTypes.object.isRequired
  }
  constructor(props){
    super(props)
    this.state = {
      open: props.url.hash === '#resolution'
    }
  }

  render() {
    const { planId, planData } = this.props
    const { open } = this.state

    // companies that have resolutions
    const resolutionTexts = {
      'amazon-com': <AmazonResolutionText />,
      'comcast': <ComcastResolutionText />,
      'microsoft': <MicrosoftResolutionText />,
      'campbell-soup': <CampbellSoupResolutionText />,
    }

    // nothing if no resolution text
    if (!Object.keys(resolutionTexts).includes(planId)){ return null }

    // from plan data, sum:
    //   TD deforest $USD
    //   equity deforest $USD
    //   TD fossil fuel $USD
    //   equity fossil fuel $USD
    const climateRiskInvestments = format.money(
      planData.screen_results.dff[0] +
        planData.screen_results.dff[1] +
        planData.screen_results.fff[0] +
        planData.screen_results.fff[1],
      true,
      true
    )

    return (
      <div styleName='plan-scorecard-company-resolution'>
        <div styleName='anchor' id='resolution' />
        <button
          styleName='section-slidedown-button'
          onClick={
            (e)=>{
              this.setState({
                open: !open
              })
            }
          }
        >
          <h2 styleName='section-slidedown-label'>
            Our shareholder resolution
          </h2>
          <div styleName='section-slidedown-icon'>
            <LinkIcon faclass={ open ? 'fa-angle-up' : 'fa-angle-down' } />
          </div>
        </button>
        <SlideDown>
          {
            open ?
              <div>
                { /* EXPIRED */
                  planId === 'amazon-com' ||
                  planId === 'campbell-soup' ||
                  planId === 'comcast' ||
                  planId === 'microsoft' ?
                    <p>
                      We filed a shareholder resolution that went to vote at {planData.short_name}'s most recent Annual General Meeting. Our resolution asked: Why is the company saying “{planData.climate_claim},” and at the same time directing {climateRiskInvestments} of employee savings into fossil fuels and rainforest destruction? Click through below to learn more about the results for this resolution.
                    </p> :
                    null
                }
                { resolutionTexts[planId] }

                { /* EXAMPLE ACTIVE
                  planId === 'campbell-soup' ?
                    (
                      <div>
                        <Link
                          to={config.routes.resolutionLanding + '/' + planId}
                          title={planData.short_name + ' investors: Vote YES on ' + planData.proposal_title}
                          targetBlank
                        >
                          <h3 styleName='resolution-section-title'>
                            {planData.short_name} investors: Vote YES on {planData.proposal_title}
                          </h3>
                        </Link>
                        <p>
                          We've filed a shareholder resolution that is going to vote at the upcoming {planData.short_name} Annual General Meeting. This year, if you own shares in {planData.short_name}, you can vote YES on our resolution to ask: Why is the company saying “{planData.climate_claim},” and at the same time directing {climateRiskInvestments} of employee savings into fossil fuels and rainforest destruction?
                        </p>
                        <p>
                          <button>
                            <Link
                              to={config.links.proxyvote}
                              title='Vote your proxy now with your control number'
                              primarybutton
                            >
                              <div styleName='sidebar-button'>
                                Vote now<LinkIcon/>
                              </div>
                            </Link>
                          </button>
                          <span>&nbsp;&nbsp;&nbsp;</span>
                          <button>
                            <Link
                              to={config.routes.resolutionLanding + '/' + planId}
                              title='Learn more about how to vote'
                              orangebutton
                            >
                              <div styleName='sidebar-button'>
                                Learn more<LinkIcon/>
                              </div>
                            </Link>
                          </button>
                        </p>
                      </div>
                    ) :
                    null
                  */ }
              </div> :
              null
          }
        </SlideDown>
      </div>
    )
  }
}